import React, { HTMLProps } from "react";
import cn from "classnames";
import s from "../FilterPage.module.scss";

const Toggle = ({ className, ...props }: HTMLProps<HTMLDivElement>) => (
  <div {...props} className={cn(className, s.toggle)} />
);

export default Toggle;
